module.exports = __webpack_public_path__ + "static/media/apple_iphone-11-pro-max_green.3ea0e29e.png";